import { render, staticRenderFns } from "./CustomAttributesSelectValues.vue?vue&type=template&id=9f5c7ddc"
import script from "./CustomAttributesSelectValues.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesSelectValues.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports